import { ReadSyncValidationsDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useLazyQuery } from 'modules/core/hooks/useQuery'

import { useIntegrationsSyncContext } from 'modules/integrations/hooks/SyncContext'
import {
  BlockingIssue,
  useCompensationsBlockingIssues,
} from 'modules/integrations/hooks/SyncContext/blockingIssues'

interface UseBlockingIssuesLazyQueryResult {
  fetchBlockingIssues: () => Promise<void>
  blockingIssues: BlockingIssue[]
  blockingIssuesLoading: boolean
}

export const useBlockingIssuesLazyQuery = (): UseBlockingIssuesLazyQueryResult => {
  const {
    syncEnabled,
    marketplaceIntegration,
    contextParameters,
    getDataCollectionSource,
    configuration,
  } = useIntegrationsSyncContext()

  const {
    company: { id: companyId },
  } = useCurrentSession()
  const [
    fetchSyncValidationsQuery,
    { data: blockingIssuesData, loading: blockingIssuesLoading, networkActivity },
  ] = useLazyQuery(ReadSyncValidationsDocument)

  const blockingIssues =
    blockingIssuesData?.integrations?.syncValidationsConnection.nodes[0]?.blockingIssues || []

  const fetchBlockingIssues = async () => {
    if (!syncEnabled || !marketplaceIntegration) return

    const dataCollectionSource = getDataCollectionSource()

    const payrollRunId = String(
      contextParameters.payroll_run_id || dataCollectionSource?.mappedVariables?.payrollRunId
    )

    await fetchSyncValidationsQuery({
      variables: {
        companyId,
        marketplaceIntegrationId: marketplaceIntegration.id,
        capabilityType: configuration.capabilityType,
        parameters: [{ key: 'payroll_run_id', value: payrollRunId }],
      },
    })
  }

  return {
    fetchBlockingIssues,
    blockingIssues: useCompensationsBlockingIssues(blockingIssues, marketplaceIntegration),
    blockingIssuesLoading: networkActivity || blockingIssuesLoading,
  }
}
